module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkAQAAAABYmaj5AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAd2KE6QAAAAHdElNRQfdCggPCBbaIe17AAAAS0lEQVQ4y2P4jwQ+MAww7wADDNgPAh7zf4jQIODx//+P5LKB5YFdBhIaJLz///8wDAoeAzA5f2D+Pxh4/CBHwV02sLxBlKcHT1kHAFm6xkdKVpRPAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE4LTA4LTEzVDE1OjI3OjA5KzA5OjAwtvXhfwAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxMy0xMC0wOFQwNjowODoyMiswOTowMD+oKM0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/tag/36h10/tag36_10_01947_100x100.png
// module id = Nv4+
// module chunks = 0